import { ButtonsContainer } from './styled';
export function ToggleTabsButtonsContainer(props) {
    const { children, stretch = false, size = 'medium' } = props;
    return (<ButtonsContainer $stretch={stretch} $size={size}>
      {children}
    </ButtonsContainer>);
}
